import {
    Card,
    Descriptions,
    Drawer,
    Row,
    Col,
    Typography,
    Divider,
    Tag
}
    from "antd";

export default function PaymentCard({
                                          conversation
                                      }) {

    const {
        product
    } = conversation;

    return (
        <Card
            style={{
                background:"#e6f4ff"
            }}
        >

            <Typography.Title level={5}>
                💳 Paiement
            </Typography.Title>

            <Tag color="processing">
                EN ATTENTE
            </Tag>

            <div>
                Provider :
                CinetPay
            </div>

            <div>
                Montant :
                64 000 FCFA
            </div>

        </Card>
    );
}